






























import Vue from 'vue'
import { mapMutations } from 'vuex'
import { ADD_TOAST_MESSAGE } from 'vuex-toast'
import i18n from '@/i18n'
import BaseLayout from '@/layout/BaseLayout.vue'
import ScriptScheme from '@/components/Scheme/ScriptScheme.vue'
import ScriptStatusIcon from '@/components/Scripts/ScriptStatusIcon.vue'
import ScriptPreviewButtons from '@/components/Script/ScriptPreviewButtons.vue'
import ScriptEditSaveButtons from '@/components/Script/ScriptEditSaveButtons.vue'
import ScriptTitleInlineEditor from '@/components/ScriptTitleInlineEditor/ScriptTitleInlineEditor.vue'
import store from '@/store'
import { SCRIPTS__FETCH_ONE, SCRIPTS__FETCH_CARDS } from '@/store/actions'
import { _SCHEME__RESTORE_COLLAPSE_OPTION } from '@/store/mutations'

import type { Route } from 'vue-router'
import type { ScriptUnit, ScriptVersion } from '@/models/scripts'
import { RouteNames } from '@/router'

interface Methods {
  [_SCHEME__RESTORE_COLLAPSE_OPTION]: () => void
}

interface Computed {
  isEdit: boolean
  scriptId: string
  instanceId?: string
  scriptItem?: ScriptUnit
  scriptInstance?: ScriptVersion,
  scriptTitle: string
}

async function loadScript(to: Route, from: Route, next: () => void) {
  const { scriptId, instanceId } = to.params

  await Promise.all([
    store.dispatch(SCRIPTS__FETCH_ONE, { id: scriptId }),
    store.dispatch(SCRIPTS__FETCH_CARDS, {
      id: scriptId,
      instanceId,
    }),
  ]).catch((err: string) => {
    if (err) {
      store.dispatch(ADD_TOAST_MESSAGE, {
        text: i18n.tc('errors.scriptLoadFail'),
        type: 'danger',
      })
    }
  })

  next()
}

export default Vue.extend<{}, Methods, Computed, {}>({
  beforeRouteEnter: loadScript,
  beforeRouteUpdate: loadScript,
  components: {
    BaseLayout,
    ScriptScheme,
    ScriptStatusIcon,
    ScriptPreviewButtons,
    ScriptEditSaveButtons,
    ScriptTitleInlineEditor,
  },
  computed: {
    isEdit(): boolean {
      return this.$route.name === RouteNames.ScriptSchemeEdit
    },
    scriptId(): string {
      return this.$route.params.scriptId
    },
    instanceId(): string | undefined {
      return this.$route.params.instanceId
    },
    scriptItem(): ScriptUnit | undefined {
      return this.$store.getters.getScriptById(this.scriptId)
    },
    scriptInstance(): ScriptVersion | undefined {
      if (!this.instanceId || !this.scriptItem) {
        return
      }
      return this.scriptItem.versions?.find(
        v => v.instance.id === this.instanceId,
      )
    },
    scriptTitle(): string {
      return (
        this.scriptInstance?.instance.name || this.scriptItem?.title || this.$tc('common.noName')
      )
    },
  },
  methods: {
    ...mapMutations([_SCHEME__RESTORE_COLLAPSE_OPTION]),
  },
  created() {
    this[_SCHEME__RESTORE_COLLAPSE_OPTION]()
  },
  metaInfo: {
    title: 'Схема скрипта',
  },
})
